<div class="row">
  <div class="col-md-12 col-lg-10 offset-1">
    @if (alertInfo.show) {
      <ngb-alert class="m-3" [type]="alertInfo.type" (closed)="alertInfo.show = false">
        {{ alertInfo.message }}
      </ngb-alert>
    }

    @if (complaintId) {
      <div class="card">
        <div class="card-header bg-light font-weight-bold">CONVERSATION</div>
        <div class="card-body">
          @if (isTakingCare || messages.length > 0) {
            <div class="messages-container mb-3" style="max-height: 400px; overflow-y: auto;">
              @for (message of messages; track message; let i = $index) {
                <div [ngClass]="{'mb-3': true, 'd-flex': true, 'justify-content-end': isCurrentUserMessage(message), 'justify-content-start': !isCurrentUserMessage(message)}">
                  <div [ngClass]="{'message-wrapper': true, 'sent': isCurrentUserMessage(message), 'received': !isCurrentUserMessage(message)}" style="max-width: 75%;">
                    @if (!isCurrentUserMessage(message)) {
                      <div class="d-flex align-items-start">
                        <div class="user-avatar bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-2"
                          style="width: 32px; height: 32px; font-size: 14px; flex-shrink: 0;">
                          {{ (message.user?.firstName || 'U').charAt(0) }}
                        </div>
                        <div class="flex-grow-1">
                          <div class="d-flex justify-content-between align-items-start mb-1">
                            <div class="fw-bold">
                              {{ message.user ? message.user.firstName + ' ' + message.user.lastName : 'Unknown User' }}
                            </div>
                          </div>
                          <div class="message-bubble bg-light p-3 rounded">
                            <div class="message-text" style="white-space: pre-wrap;">{{ message.text }}</div>
                            <div class="text-muted small mt-2">
                              {{ formatMessageDate(message.createTime) }}
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    @if (isCurrentUserMessage(message)) {
                      <div class="d-flex align-items-start">
                        <div class="flex-grow-1 text-end">
                          <div class="mb-1">
                            <div class="fw-bold">
                              {{ message.user ? message.user.firstName + ' ' + message.user.lastName : 'Unknown User' }}
                            </div>
                          </div>
                          <div class="message-bubble bg-primary text-white p-3 rounded">
                            <div class="message-text" style="white-space: pre-wrap;">{{ message.text }}</div>
                            <div class="text-white-50 small mt-2">
                              {{ formatMessageDate(message.createTime) }}
                            </div>
                          </div>
                        </div>
                        <div class="d-flex flex-column align-items-center ms-2">
                          <div class="user-avatar bg-success text-white rounded-circle d-flex align-items-center justify-content-center"
                            style="width: 32px; height: 32px; font-size: 14px; flex-shrink: 0;">
                            {{ (message.user?.firstName || 'U').charAt(0) }}
                          </div>
                          @if (isTakingCare) {
                            <button class="btn btn-link text-danger p-0 mt-1"
                              style="font-size: 0.9rem;"
                              (click)="confirmDelete(message.complaintMessageId!)"
                              title="Delete message">
                              <i class="fa fa-trash"></i>
                            </button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
          @if (!readonly && canSendMessage()) {
            <div>
              <form [formGroup]="speechForm">
                <div class="row">
                  <div class="col-md-12">
                    <textarea-field placeholder="Type here your answer"
                      [textareaFormControl]="getMessageControl()" [readonly]="false" [height]="100" />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-12 text-end">
                    <button type="button" class="btn btn-success" [disabled]="speechForm.invalid"
                      (click)="sendMessage()">
                      <i class="fa fa-send"></i> Send
                    </button>
                  </div>
                </div>
              </form>
            </div>
          }
        </div>
      </div>
    }

  </div>
</div>